module.exports = __webpack_public_path__ + "img/gov-logo.a1fe66d5.png";